module.exports = __webpack_public_path__ + "files/fa7198d1c47e0a6cf5b35f0036be2304.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/lato-bold-webfont.ttf
 ** module id = 921
 ** module chunks = 0
 **/